module.exports = __webpack_public_path__ + "img/744.bfc6b355.jpg";